import {
    ChangeItemValueTypeEnum,
    CompanySettingModel,
    CustomerResponseModel,
    DailyTransactionTypeEnum,
    DeleteTransactionRequestModel,
    RowStateEnum,
    SearchDailyTransactionTypeEnum,
    SearchTransactionRequestModel,
    SupplierCustomerTypeEnum,
    TransactionDetailResponseModel,
    TransactionItemResponseModel,
    transactionPrintRequestModel,
    UserSettingModel,
    UserTransactionsSettingResponseModel
} from "../../../../models";
import {getSystemLanguageId, getUserId, getUserStationId} from "../../../../utils";

const deleteTransactionInitialValue: DeleteTransactionRequestModel = {
    TrnsactionId: 0,
    TransactionTypeId: DailyTransactionTypeEnum.SalesInvoice,
    User_ID: getUserId(),
    VoucherSetting_ID: 0,
    DeleteReason: "",
    ValueOfPoint: 0,
    InstallmentPlanId: 0,
    IsContainsItemSerial: false,
    ItemSerialList: [],
};
const printTransactionInitialValue:transactionPrintRequestModel= {
    id: null,
    show: false,
};
// const searchListInitialValues: SearchTransactionRequestModel = {
//     pageNumber: 1,
//     pageSize: 50,
//     transactionType: DailyTransactionTypeEnum.None,
//     searchType: SearchDailyTransactionTypeEnum.itemName,
//     searchValue: "",
// };

 const searchListInitialValues = (
    transactionType: DailyTransactionTypeEnum | null = null
): SearchTransactionRequestModel => ({
    pageNumber: 1,
    pageSize: 50,
    transactionType: transactionType ?? DailyTransactionTypeEnum.None,
    searchType: SearchDailyTransactionTypeEnum.itemName,
    searchValue: "",
    itemName: null,
    itemBarcode: null,
    itemCode: null,
    code: null,
});
 const transactionDetailInitialValues :  TransactionDetailResponseModel = {
        Code: "",
        TransactionType: 0,
        CalcType_ID: null,
        InvoiceType: null,
        PaymentType_ID: null,
        Currency_ID: null,
        ValueCurrency: 1,
        Customer_ID: null,
        User_Update: 0,
        User_Create: getUserId(),
        Emp_ID: 0,
        Station_ID: getUserStationId(),
        Table_ID: 0,
        TempHeaderID: 0,
        Refrence: 0,
        IsPrinted: false,
        Date: new Date(),
        DueDate: new Date(new Date().setDate(new Date().getDate() + 1)),
        minDueDate: new Date(new Date().setDate(new Date().getDate() + 1)),
        discountRatio: 0,
        Discount: 0,
        TotalMony: 0,
        TotalTax: 0,
        TotalNet: 0,
        DiscountInCurrency: 0,
        TotalMonyInCurrency: 0,
        TotalTaxInCurrency: 0,
        TotalNetInCurrency: 0,

        MoneyAdd: 0,
        CashMoney: 0,
        CardMoney: 0,
        DelayMoney: 0,
        OthersMoney: 0,
        Tobacco_Value: 0,

        balance: 0,
        //isReInitializeTransactionValues:false,
        TransactionDetaillist: [],

        ID: 0,
        CreatedBy: getUserId(),
        ModifiedBy: 0,
        rowState: Number(RowStateEnum.Add),
        isReadyForInitialization: false,
        //discountLevelType:TransactionDiscountLevelTypeEnum.ItemLevel,
        //isTransactionDiscountEnabled:false,
        //isItemDiscountEnabled:true,
};
const transactionItemInitialValues: TransactionItemResponseModel = {
    Categ_ID: null,
    ItemInstore_ID: null,
    storeId: null,
    ItemUnit_ID: null,

    ItemDiscountRatio: 0,
    rowKey: "",

    TransactionHeader_ID: 0,
    TransDetail_IDParent: 0,
    ItemName: "",
    ItemName_En: "",
    ItemCode: "",
    Item_Modifiers_Json: "",
    Modifiers: undefined,
    Quantity: 1,
    defaultQuantity: 1,

    Unit_Price: 0,
    UnitPriceWithTaxCalculated: 0,
    Tax: 0,
    TotalTax: 0,
    ItemDiscount: 0,
    Total: 0,

    Unit_PriceInCurrencyCalculated: 0,
    UnitPriceWithTaxInCurrency: 0,
    TaxInCurrency: 0,
    TotalTaxInCurrency: 0,
    ItemDiscountInCurrency: 0,
    TotalInCurrency: 0,

    ValueOfCurrency: 1,
    // get  Unit_PriceComputed(): number {
    //   return  this.Unit_Price*10
    // },
    PriceCost: 0,
    Factor: 0,
    Transaction_Type: 0,

    MaxQty: 0,
    TaxPercentge: 0,

    IsGatherItem: false,
    UseExpiryDate: false,
    WithoutBalance: false,
    IsFromGatherItem: false,
    NotesDetails: "",
    Unit: "",
    UnitName: "",
    IsPrinted: false,
    ExpiryDate: "",
    ID: 0,
    CreatedBy: 0,
    ModifiedBy: 0,
    rowState: Number(RowStateEnum.Add),
    UnitBalance: 0,
    barCode: "",
    changeValueType: ChangeItemValueTypeEnum.None,
    latestModifiedDate: new Date(),
    originalItemDiscountInCurrency: 0
};
const companySettingInitialValues: CompanySettingModel = {
    Advert: undefined,
    ApplyTax: false,
    ArabicLanguage: "",
    AttachmentFolder: undefined,
    BacckGroundImage: "",
    BackColor: 0,
    BackGroundImageName: "",
    CalcDiscountWithVAT: false,
    CheckBalanceOfItemOnAdd: false,
    CompanyAddress: "",
    CompanySetting_UniqueId: "",
    Company_Address: "",
    CreatedBy: undefined,
    CreationDate: "",
    CurrencyShortCut: "",
    Currency_ID: 0,
    DateType: false,
    DaysOfDeleteBackupFiles: 0,
    DecimalPlace: 0,
    DefaultCurrency_ID: 0,
    DefaultTaxPercentage: undefined,
    EnglishLanguage: "",
    Errors: [],
    FormatDate: "",
    FormatDecimal: "",
    Header: undefined,
    HideItemFromCloseDay: false,
    ID: 0,
    IncludeVatOnEditPrice: false,
    IsCodeTransactionSeparated: false,
    IsEnableToUploadEinvoice: false,
    IsFloorSecondeCurrency: false,
    IsSentEmailReportAfterCloseDayOnly: false,
    IsTrialVersion: false,
    IsUploadShipmentTrackToCloud: false,
    IsUploadTransactionToCloud: false,
    Is_Company_Authorized_Tobacco: false,
    LogoImage: "",
    LogoImage64: "",
    LogoImageName: "",
    Mail: "",
    MaxQuantity: undefined,
    MobileReceiver: "",
    ModificationDate: "",
    ModifiedBy: undefined,
    Name: "",
    Password: "",
    PasswordSMS: "",
    PathBackUp: "",
    Phone: "",
    PrintItemArabicEngInBill: false,
    PrintItemPrescriptionOfTransaction: false,
    Printer_Tablet_List: "",
    RecivedMail: "",
    SendMailOfSalesOnClose: false,
    SendSMS: false,
    SenderName: "",
    ServiceUI: "",
    SetCostPriceZeroOnSalePriceZero: false,
    SetScaleOnPrice: false,
    SetScaleWeightonKG: false,
    ShowItemPriceWithoutTax: false,
    SoftwareName: undefined,
    SystemSettings: "",
    TaxNumber: "",
    TermsAndCondations: "",
    TextLogo: "",
    Token: undefined,
    TransferTaxToDiscount: false,
    UseOldModelForSearch: false,
    UserNameSMS: "",
    ValueOfCurrency: 0,
    ValueOfPoint: 0,
    VerifyOnUpdate: false,
    WaterMarkImage: "",
    isInitialRequest: false,
    rowState: 0,
    voucherSettings: undefined
}
const userSettingInitialValues: UserSettingModel = {
    AddItemInNewLineInBill: false,
    AlertOfCustomerDidintPaySince: 0,
    AllowItemPriceSaleLessThanCost: false,
    AllowSaleLessThanCost: false,
    AlowRepeateFactoItemUnit: false,
    CheckMaxDebitOfCustomer: false,
    CreatedBy: 0,
    CreationDate: new Date(),
    DaysAlertBeforeExpire: 0,
    EnableManualInvoiceCode: true,
    ID: 0,
    Lang: getSystemLanguageId(),
    MaxDiscountPercentage: 0,
    ModificationDate: new Date(),
    ModifiedBy: 0,
    Name: "",
    PeriodAllowToEdit: 0,
    ShowScaleBarcode: false,
    PreventStoreOutOfItemLessZero: false,
    PrintBarcodeAfterPurches: false,
    PrintItemPrescriptionAfterSale: false,
    RequestDueDateOnDelayPayment: false,
    RigesterBillOnPayment: false,
    SelectionEmployeeIsRequierd: false,
    ShowAlert: false,
    ShowBarcode: false,
    ShowItemModifiers: false,
    ShowMinimumPriceItem: false,
    ShowProfitOfBill: false,
    User_ID: getUserId(),
    VerifyOnUpdate: false,
    rowState: 1,
    isArabic: false,
    isEnglish: false,ShowHintOfItemCost: false,
};
const companySettingsInitialValues: CompanySettingModel = {
    Advert: undefined,
    ApplyTax: false,
    ArabicLanguage: "",
    AttachmentFolder: undefined,
    BacckGroundImage: "",
    BackColor: 0,
    BackGroundImageName: "",
    CalcDiscountWithVAT: false,
    CheckBalanceOfItemOnAdd: false,
    CompanyAddress: "",
    CompanySetting_UniqueId: "",
    Company_Address: "",
    CreatedBy: undefined,
    CreationDate: "",
    CurrencyShortCut: "",
    Currency_ID: 0,
    DateType: false,
    DaysOfDeleteBackupFiles: 0,
    DecimalPlace: 0,
    DefaultCurrency_ID: 0,
    DefaultTaxPercentage: 0,
    EnglishLanguage: "",
    Errors: [],
    FormatDate: "",
    FormatDecimal: "",
    Header: undefined,
    HideItemFromCloseDay: false,
    ID: 0,
    IncludeVatOnEditPrice: false,
    IsCodeTransactionSeparated: false,
    IsEnableToUploadEinvoice: false,
    IsFloorSecondeCurrency: false,
    IsSentEmailReportAfterCloseDayOnly: false,
    IsTrialVersion: false,
    IsUploadShipmentTrackToCloud: false,
    IsUploadTransactionToCloud: false,
    Is_Company_Authorized_Tobacco: false,
    LogoImage: "",
    LogoImage64: "",
    LogoImageName: "",
    Mail: "",
    MaxQuantity: 0,
    MobileReceiver: "",
    ModificationDate: "",
    ModifiedBy: undefined,
    Name: "",
    Password: "",
    PasswordSMS: "",
    PathBackUp: "",
    Phone: "",
    PrintItemArabicEngInBill: false,
    PrintItemPrescriptionOfTransaction: false,
    Printer_Tablet_List: "",
    RecivedMail: "",
    SendMailOfSalesOnClose: false,
    SendSMS: false,
    SenderName: "",
    ServiceUI: "",
    SetCostPriceZeroOnSalePriceZero: false,
    SetScaleOnPrice: false,
    SetScaleWeightonKG: false,
    ShowItemPriceWithoutTax: false,
    SoftwareName: undefined,
    SystemSettings: "",
    TaxNumber: "",
    TermsAndCondations: "",
    TextLogo: "",
    Token: undefined,
    TransferTaxToDiscount: false,
    UseOldModelForSearch: false,
    UserNameSMS: "",
    ValueOfCurrency: 0,
    ValueOfPoint: 0,
    VerifyOnUpdate: false,
    WaterMarkImage: "",
    rowState: 0,
    voucherSettings: undefined,
    isInitialRequest:true
};
const userTransactionsSettingInitialValues: UserTransactionsSettingResponseModel =
    {
        DeafultNote: "",
        DefaultCalcTypeID: 0,
        DefaultPaymentTypeID: 0,
        DirectPrintBillAfterSave: false,
        EnableButonAdd: false,
        EnableDiscount: false,
        EnablePrint: false,
        EnableShangPrice: false,
        ID: 0,
        Name: null,
        NumberOfCopy: 0,
        PeriodAllowForReturn: 0,
        PrinterName: "",
        PrinterPrepairingSalesInvoice: "",
        RemarksVisable: "",
        ShowButtonPrintPrepairingOrder: false,
        ShowCalcType: false,
        ShowCinfirm: false,
        ShowCostCenter: false,
        ShowCurrency: false,
        ShowCustomerCar: false,
        ShowDone: false,
        ShowEmployeeResponsibile: false,
        ShowNotefy: false,
        ShowPaymentType: false,
        ShowPrice: false,
        ShowPrintStickerButton: false,
        ShowRefrence: false,
        ShowSaveAndPrintButton: false,
        ShowTransPortCost: false,
        TransactionType_ID: 0,
        User_ID: 0,
        VerifyOnUpdate: false,
        rowState: 0,
    };
const customerInitialValue: CustomerResponseModel = {
    Code: 0,
    IDNumber: "",
    City_ID: 0,
    Address: "",
    Mobile: "",
    Phone: "",
    Mail: "",
    Notes: "",
    Cust_Type: Number(SupplierCustomerTypeEnum.Customer),
    Beg_AC_Bal: 0,
    AreaLand: "",
    User_ID: 0,
    Account_ID: 0,
    ISCustomerAndSupplier: false,
    PaymentTypeID: 0,
    Currency_ID: 0,
    ValueCurrency: 0,
    BalanceOfPoint: 0,
    IsDefault: false,
    MaxDebit: 0,
    Customer_UniqueID: 0,
    Name_En: "",
    TaxNumber: "",
    IsCopyToServer: true,
    Device_ID: 0,
    IsSponsor: false,
    Sponsor_Id: 0,
    IsActive: true,
    ProfitPercentage: 0,
    CustomerType: "",
    address: {
        CountryCode: "",
        FlatNumber: "",
        Governate: "",
        CreatedBy: 0,
        CreationDate: new Date(),
        ModificationDate: new Date(),
        CustomerId: 0,
        Address_GUID: "",
        ID: 0,
        ModifiedBy: 0,
        Name: "",
        RegionCity: "",
        Remarks: "",
        Row_State: 1,
        Street: "",
        VerifyOnUpdate: false,
        buildingNumber: "",
        rowState: 1,
    },
    IsCreateAccountOnSaveNewOne: false,
    IsSkipSaveAccount: false,
    ID: 0,
    CreatedBy: 0,
    ModifiedBy: 0,
    Name: "",
    ModificationDate: new Date(),
    VerifyOnUpdate: false,
    rowState: 1,
};
export {deleteTransactionInitialValue,printTransactionInitialValue,searchListInitialValues,transactionDetailInitialValues,transactionItemInitialValues,companySettingInitialValues,userSettingInitialValues,companySettingsInitialValues,userTransactionsSettingInitialValues,customerInitialValue};